/**
 * binning.js
 * Shared price-bin utilities used across Vuex getters and components.
 */

/**
 * Return the lower bound of the bin that contains `price`.
 * e.g. getPriceBin(65432, 1000) → 65000
 * @param {number} price
 * @param {number} binSize
 * @returns {number}
 */
export function getPriceBin(price, binSize) {
  return Math.floor(price / binSize) * binSize;
}

/**
 * Consistent string key for a bin number (8 decimal places avoids
 * floating-point equality issues when using a Map/Object).
 * @param {number} bin  — result of getPriceBin
 * @returns {string}
 */
export function getBinKey(bin) {
  return bin.toFixed(8);
}
